export default "__VITE_ASSET__OVm6GwZ5__"